import { Component, OnInit, HostListener, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridsterConfig, GridsterItem } from 'angular-gridster2';
import { AppSettingService, AppUtilityService } from '../app.service';
import { ActivityAPIService } from '../user/user-api.service';
import { CollegeScorecardAPIService, CollegeScorecardService} from './college-scorecard.service';
import { UtilityService } from '../utility/utility.service';
import { SocialObjectAPIService, ESocialSourceType } from '../socialObject/social-object.service';

interface IAtAGlanceItem {
	iconType: "html" | "css",
	dataType: "html" | "text"
	icon: string,
	data?: string,
	text: string
}

@Component({
	selector: 'app-college-scorecard-school',
	templateUrl: './college-scorecard-school.component.html',
	styleUrls: ['./college-scorecard.scss'],
	standalone: false
})
export class CollegeScorecardSchoolComponent implements OnInit {
	constructor(
		private CSCAPI: CollegeScorecardAPIService,
		public CSCSrv: CollegeScorecardService,
		private route: ActivatedRoute,
		private activityAPI: ActivityAPIService
	) { }

	gridsterOptions: GridsterConfig = AppSettingService.gridsterOptions;
	mobileView: boolean = AppSettingService.widgetMobile();
	status: number = 0;
	schoolId: string = "";
	school: any = null;

	//#region gridster items
	atAGlanceDimensions: GridsterItem = { x: 1, y: 0, cols: 2, rows: 4 };
	descriptionDimensions: GridsterItem = { x: 3, y: 0, cols: 8, rows: 4 };
	googleMapDimensions: GridsterItem = { x: 1, y: 4, cols: 10, rows: 2 };
	academicProgDimensions: GridsterItem = { x: 1, y: 6, cols: 10, rows: 4 };
	testScoreDimensions: GridsterItem = { x: 1, y: 10, cols: 3, rows: 3 };
	gradDimensions: GridsterItem = { x: 4, y: 10, cols: 3, rows: 3 };
	costDimensions: GridsterItem = { x: 7, y: 10, cols: 4, rows: 3 };
	financeDimensions: GridsterItem = { x: 1, y: 13, cols: 6, rows: 3 };
	earningDimensions: GridsterItem = { x: 7, y: 13, cols: 4, rows: 3 };

	gstItems = {
		giDescription: false,
		giAtGlance: false,
		giMap: false,
		giProgram: false,
		giTestScores: false,
		giGraduationRetention: false,
		giCost: false,
		giFinancialAidDebt: false,
		giEarningsAfterSchool: false
	}
	//#endregion gridster items

	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.mobileView = AppSettingService.widgetMobile();

		let width: number = window.innerWidth;
		if (width <= 1300 && width >= 992) {
			this.testScoreDimensions.cols = 3;
			this.testScoreDimensions.rows = 6;
			this.gradDimensions.cols = 3;
			this.gradDimensions.rows = 6;
			this.gradDimensions.x = 4;
			this.gradDimensions.y = 10;
			this.costDimensions.cols = 4;
			this.costDimensions.rows = 6;
			this.costDimensions.x = 7;
			this.costDimensions.y = 10;
			this.financeDimensions.cols = 6;
			this.financeDimensions.rows = 5;
			this.financeDimensions.x = 1;
			this.financeDimensions.y = 16;
			this.earningDimensions.cols = 4;
			this.earningDimensions.rows = 5;
			this.earningDimensions.x = 7;
			this.earningDimensions.y = 16;
		}
		else {
			if (width < 1600 && width > 1300) {
				this.testScoreDimensions.cols = 3;
				this.testScoreDimensions.rows = 4;
				this.gradDimensions.cols = 3;
				this.gradDimensions.rows = 4;
				this.gradDimensions.x = 4;
				this.gradDimensions.y = 10;
				this.costDimensions.cols = 4;
				this.costDimensions.rows = 4;
				this.costDimensions.x = 7;
				this.costDimensions.y = 10;
				this.financeDimensions.cols = 6;
				this.financeDimensions.rows = 4;
				this.financeDimensions.x = 1;
				this.financeDimensions.y = 14;
				this.earningDimensions.cols = 4;
				this.earningDimensions.rows = 4;
				this.earningDimensions.x = 7;
				this.earningDimensions.y = 14;
			}
			else {
				this.testScoreDimensions.cols = 3;
				this.testScoreDimensions.rows = 3;
				this.gradDimensions.cols = 3;
				this.gradDimensions.rows = 3;
				this.gradDimensions.x = 4;
				this.gradDimensions.y = 10;
				this.costDimensions.cols = 4;
				this.costDimensions.rows = 3;
				this.costDimensions.x = 7;
				this.costDimensions.y = 10;
				this.financeDimensions.cols = 6;
				this.financeDimensions.rows = 3;
				this.financeDimensions.x = 1;
				this.financeDimensions.y = 13;
				this.earningDimensions.cols = 4;
				this.earningDimensions.rows = 3;
				this.earningDimensions.x = 7;
				this.earningDimensions.y = 13;
			}
		}
		/*
		console.log('testScoreDimensions', this.testScoreDimensions);
		console.log('gradDimensions', this.gradDimensions);
		console.log('costDimensions', this.costDimensions);
		console.log('financeDimensions', this.financeDimensions);
		console.log('earningDimensions', this.earningDimensions);
		*/
		try { this.gridsterOptions.api.optionsChanged(); }
		catch (ex) { ; }
	}


	//#region at Glance
	atAGlanceData: IAtAGlanceItem[] = [];
	schoolYear(noStyle: boolean = false): string {
		try {
			if (this.school.SchoolYear.length == 0) {
				throw "no data";
			}
			if (noStyle === true) {
				return "<div class='ellipsis'>" + this.school.Type + "</div>";
			}
			else {
				return "<span style='font-weight:normal'>" + this.school.SchoolYear + " year</span><br/><span style='font-size:15px;font-weight:bold;'  class='ellipsis'>" + this.school.Type + "</span>";
			}
		}
		catch (ex) {
			return "<span style='color:#a0a0a0'  class='ellipsis'>Data not available</span>";
		}
	}

	studentSize(noStyle: boolean = false): string {
		try {
			var size = this.school.Student.StudentSize.trim();
			if (size == 0) {
				throw "no data";
			}
			if (noStyle === true) {
				return "<div>" + AppUtilityService.toCommaNumber(size) + "</div>";
			}
			else {
				return "<span style='font-size:15px;font-weight:bold;'>" + AppUtilityService.toCommaNumber(size) + "</span>";
			}
		}
		catch (ex) {
			return "<span style='color:#a0a0a0'>Data not available</span>";
		}
	}

	schoolLocation(noStyle: boolean = false): string {
		try {
			if (this.school.Locale.length == 0) {
				throw "no data";
			}
			var locale = this.school.Locale.indexOf(":") > 0 ? this.school.Locale.split(":")[0] : this.school.Locale;
			var title = this.school.Locale.indexOf(":") > 0 ? this.school.Locale.split(":")[1] : "";
			if (noStyle === true) {
				return "<div title='" + title + "'>" + locale + "</div>";
			}
			else {
				return "<span style='font-size:15px;font-weight:bold;' title='" + title + "' class='ellipsis'>" + locale + "</span>";
			}
		}
		catch (ex) {
			return "<span style='color:#a0a0a0' class='ellipsis'>Data not available</span>";
		}
	}

	classsrooms(noStyle: boolean = false): string {
		try {
			var size = this.school.Student.StudentSizeCategory.trim();
			if (size == 0) {
				throw "no data";
			}
			if (noStyle === true) {
				return "<div>" + this.school.Student.StudentSizeCategory + "</div>";
			}
			else {
				return "<span style='font-size:15px;font-weight:bold;'>" + this.school.Student.StudentSizeCategory + "</span>";
			}
		}
		catch (ex) {
			return "<span style='color:#a0a0a0'>Data not available</span>";
		}
	}

	cost(noStyle: boolean = false): string {
		try {
			var v = this.school.Cost.AverageAnnualCost.trim();
			var navg = this.school.Cost.CostNationalAverage.trim();
			if (v.length == 0) {
				throw "no data";
			}
			var m = "", c = "";
			if (v == navg) { m = "<i class='fa fa-check fa-1' aria-hidden='true'></i> About Average"; c = "2b6091"; }
			else if (v >= navg) { m = "<i class='icnArrowUp fa-1' aria-hidden='true'></i> Above Average"; c = "dc4116"; }
			else { m = "<i class='icnArrowDown fa-1' aria-hidden='true'></i> Lower Than Average"; c = "77b713"; }
			if (noStyle === true) {
				return "<div title='Data:" + AppUtilityService.toCommaNumber(v) + " Average:" + AppUtilityService.toCommaNumber(navg) + "' style='color:#" + c + "' class='ellipsis'>" + m + "</div>";
			}
			else {
				return "<span title='Data:" + AppUtilityService.toCommaNumber(v) + " Average:" + AppUtilityService.toCommaNumber(navg) + "' style='font-size:15px; font-weight:bold; color:#" + c + "' class='ellipsis'>" + m + "</span>";
			}
		}
		catch (ex) {
			return "<span style='color:#a0a0a0'>Data not available</span>";
		}
	}

	graduationRate(noStyle: boolean = false): string {
		try {
			var v = this.school.GraduationRetention.GraduationRate.trim();
			var navg = this.school.GraduationRetention.GraduationRateNationalAverage.trim();
			if (v.length == 0) {
				throw "no data";
			}
			var m = "", c = "";
			if (navg.length == 0) {
				return v + "Not Rated";
			}
			else {
				if (v == navg) { m = "<i class='fa fa-check fa-1' aria-hidden='true'></i> About Average"; c = "2b6091"; }
				else if (v >= navg) { m = "<i class='icnArrowUp fa-1' aria-hidden='true'></i> Above Average"; c = "77b713"; }
				else { m = "<i class='icnArrowDown fa-1' aria-hidden='true'></i> Lower Than Average"; c = "dc4116"; }
				if (noStyle === true) {
					return "<div title='Data:" + AppUtilityService.toCommaNumber(v) + " Average:" + AppUtilityService.toCommaNumber(navg) + "' style='color:#" + c + "' class='ellipsis'>" + m + "</div>";
				}
				else {
					return "<span title='Data:" + AppUtilityService.toCommaNumber(v) + " Average:" + AppUtilityService.toCommaNumber(navg) + "' style='font-size:15px; font-weight:bold; color:#" + c + "' class='ellipsis'>" + m + "</span>";
				}
			}
		}
		catch (ex) {
			return "<span style='color:#a0a0a0'>Data not available</span>";
		}
	}

	returningStudents(noStyle: boolean = false): string {
		try {
			var v = this.school.GraduationRetention.StudentsWhoReturnAfter1stYear.trim();
			var navg = this.school.GraduationRetention.RetentionNationalAverage.trim();
			if (v.length == 0) {
				throw "no data";
			}
			var m = "", c = "";
			if (navg.length == 0) {
				return v + "Not Rated";
			}
			else {
				if (v == navg) { m = "<i class='fa fa-check fa-1' aria-hidden='true'></i> About Average"; c = "2b6091"; }
				else if (v >= navg) { m = "<i class='icnArrowUp fa-1' aria-hidden='true'></i> Above Average"; c = "77b713"; }
				else { m = "<i class='icnArrowDown fa-1' aria-hidden='true'></i> Lower Than Average"; c = "dc4116"; }
				if (noStyle === true) {
					return "<div title='Data:" + AppUtilityService.toCommaNumber(v) + " Average:" + AppUtilityService.toCommaNumber(navg) + "' style='color:#" + c + "' class='ellipsis'>" + m + "</div>";
				}
				else {
					return "<span title='Data:" + AppUtilityService.toCommaNumber(v) + " Average:" + AppUtilityService.toCommaNumber(navg) + "' style='font-size:15px; font-weight:bold; color:#" + c + "' class='ellipsis'>" + m + "</span>";
				}
			}
		}
		catch (ex) {
			return "<span style='color:#a0a0a0'>Data not available</span>";
		}
	}

	earningsAfterSchool(noStyle: boolean = false): string {
		try {
			var v = this.school.EarningAterSchool.SalaryAfterAttending.trim();
			var navg = this.school.EarningAterSchool.SalaryNationalAverage.trim();
			if (v.length == 0) {
				throw "no data";
			}
			var m = "", c = "";
			if (navg.length == 0) {
				return v + "Not Rated";
			}
			else {
				if (v == navg) { m = "<i class='fa fa-check fa-1' aria-hidden='true'></i> About Average"; c = "2b6091"; }
				else if (v >= navg) { m = "<i class='icnArrowUp fa-1' aria-hidden='true'></i> Above Average"; c = "77b713"; }
				else { m = "<i class='icnArrowDown fa-1' aria-hidden='true'></i> Lower Than Average"; c = "dc4116"; }
				if (noStyle === true) {
					return "<div title='Data:" + AppUtilityService.toCommaNumber(v) + " Average:" + AppUtilityService.toCommaNumber(navg) + "' style='color:#" + c + "' class='ellipsis'>" + m + "</div>";
				}
				else {
					return "<span title='Data:" + AppUtilityService.toCommaNumber(v) + " Average:" + AppUtilityService.toCommaNumber(navg) + "' style='font-size:15px; font-weight:bold; color:#" + c + "' class='ellipsis'>" + m + "</span>";
				}
			}
		}
		catch (ex) {
			return "<span style='color:#a0a0a0'>Data not available</span>";
		}
	}

	studentPayingDownDebt(noStyle: boolean = false): string {
		try {
			var v = this.school.Aid.StudentsPayingDownTheirDebt.trim();
			var navg = this.school.Aid.PayingDownNationalAverage.trim();
			if (v.length == 0) {
				throw "no data";
			}
			var m = "", c = "";
			if (navg.length == 0) {
				return v + "Not Rated";
			}
			else {
				if (v == navg) { m = "<i class='fa fa-check fa-1' aria-hidden='true'></i> About Average"; c = "2b6091"; }
				else if (v >= navg) { m = "<i class='icnArrowUp fa-1' aria-hidden='true'></i> Above Average"; c = "77b713"; }
				else { m = "<i class='icnArrowDown fa-1' aria-hidden='true'></i> Lower Than Average"; c = "dc4116"; }
				if (noStyle === true) {
					return "<div title='Data:" + AppUtilityService.toCommaNumber(v) + " Average:" + AppUtilityService.toCommaNumber(navg) + "' style='color:#" + c + "' class='ellipsis'>" + m + "</div>";
				}
				else {
					return "<span title='Data:" + AppUtilityService.toCommaNumber(v) + " Average:" + AppUtilityService.toCommaNumber(navg) + "' style='font-size:15px; font-weight:bold; color:#" + c + "' class='ellipsis'>" + m + "</span>";
				}
			}
		}
		catch (ex) {
			return "<span style='color:#a0a0a0'>Data not available</span>";
		}
	}
	//#endregion at Glance

	//schol logo, name, url, map
	schoolURL(): string {
		if (this.school != null && this.school.SchoolURL != null) {
			//console.log(this.school.SchoolURL);
			var ul = this.school.SchoolURL.trim().toLowerCase();
			if (ul.length > 0) {
				ul = (ul.indexOf("http") < 0 ? "http://" : "") + ul;
				// if the url is end with "/", try to remove it
				if (ul.substring(ul.length - 1) === "/") {
					ul = ul.substring(0, ul.length - 1);
				}
			}
			return ul;
		}
		else {
			return "";
		}
	}

	displayTestScore(): void {
		//init UI data
		this.school.UIDt.Test = {
			SAT: {
				Reading: { Min: 0, MinPcnt: 0, Max: 800, MaxPcnt: 100, Lower: 0, LowePcnt: 0, Middle: 0, MiddlePcnt: 0, Upper: 0, UpperPcnt: 0 },
				Math: { Min: 0, MinPcnt: 0, Max: 800, MaxPcnt: 100, Lower: 0, LowePcnt: 0, Middle: 0, MiddlePcnt: 0, Upper: 0, UpperPcnt: 0 },
				Writing: { Min: 0, MinPcnt: 0, Max: 800, MaxPcnt: 100, Lower: 0, LowePcnt: 0, Middle: 0, MiddlePcnt: 0, Upper: 0, UpperPcnt: 0 }
			},
			ACT: { Min: 0, MinPcnt: 0, Max: 36, MaxPcnt: 100, LLower: 0, LowePcnt: 0, Middle: 0, MiddlePcnt: 0, Upper: 0, UpperPcnt: 0 }
		}
		// populate UI data for SAT and ACT
		if (this.school != null && this.school.Admission != null) {
			if (this.school.Admission.SAT != null) {
				var sat = this.school.Admission.SAT;
				var uisat = this.school.UIDt.Test.SAT;
				try {
					uisat.Reading.Lower = sat.Percentile25.CriticalReading.length == 0 || isNaN(sat.Percentile25.CriticalReading) ? 0 : parseInt(sat.Percentile25.CriticalReading);
					uisat.Reading.LowerPcnt = Math.round(parseFloat(uisat.Reading.Lower) / parseFloat(uisat.Reading.Max) * 100);
					uisat.Reading.Middle = sat.Midpoint.CriticalReading.length == 0 || isNaN(sat.Midpoint.CriticalReading) ? 0 : parseInt(sat.Midpoint.CriticalReading);
					uisat.Reading.MiddlePcnt = Math.round(parseFloat(uisat.Reading.Middle) / parseFloat(uisat.Reading.Max) * 100);
					uisat.Reading.Upper = sat.Percentile75.CriticalReading.length == 0 || isNaN(sat.Percentile75.CriticalReading) ? 0 : parseInt(sat.Percentile75.CriticalReading);
					uisat.Reading.UpperPcnt = Math.round(parseFloat(uisat.Reading.Upper) / parseFloat(uisat.Reading.Max) * 100);
				}
				catch (ex) {
					console.log(ex);
					uisat.Reading.Lower = 0; uisat.Reading.LowerPcnt = 0;
					uisat.Reading.Middle = 0; uisat.Reading.MiddlePcnt = 0;
					uisat.Reading.Upper = 0; uisat.Reading.UpperPcnt = 0;
				}
				try {
					uisat.Math.Lower = sat.Percentile25.Math.length == 0 || isNaN(sat.Percentile25.Math) ? 0 : parseInt(sat.Percentile25.Math);
					uisat.Math.LowerPcnt = Math.round(parseFloat(uisat.Math.Lower) / parseFloat(uisat.Math.Max) * 100);
					uisat.Math.Middle = sat.Midpoint.Math.length == 0 || isNaN(sat.Midpoint.Math) ? 0 : parseInt(sat.Midpoint.Math);
					uisat.Math.MiddlePcnt = Math.round(parseFloat(uisat.Math.Middle) / parseFloat(uisat.Math.Max) * 100);
					uisat.Math.Upper = sat.Percentile75.Math.length == 0 || isNaN(sat.Percentile75.Math) ? 0 : parseInt(sat.Percentile75.Math);
					uisat.Math.UpperPcnt = Math.round(parseFloat(uisat.Math.Upper) / parseFloat(uisat.Math.Max) * 100);
				}
				catch (ex) {
					console.log(ex);
					uisat.Math.Lower = 0; uisat.Math.LowerPcnt = 0;
					uisat.Math.Middle = 0; uisat.Math.MiddlePcnt = 0;
					uisat.Math.Upper = 0; uisat.Math.UpperPcnt = 0;
				}
				try {
					uisat.Writing.Lower = sat.Percentile25.Writing.length == 0 || isNaN(sat.Percentile25.Writing) ? 0 : parseInt(sat.Percentile25.Writing);
					uisat.Writing.LowerPcnt = Math.round(parseFloat(uisat.Writing.Lower) / parseFloat(uisat.Writing.Max) * 100);
					uisat.Writing.Middle = sat.Midpoint.Writing.length == 0 || isNaN(sat.Midpoint.Writing) ? 0 : parseInt(sat.Midpoint.Writing);
					uisat.Writing.MiddlePcnt = Math.round(parseFloat(uisat.Writing.Middle) / parseFloat(uisat.Writing.Max) * 100);
					uisat.Writing.Upper = sat.Percentile75.Writing.length == 0 || isNaN(sat.Percentile75.Writing) ? 0 : parseInt(sat.Percentile75.Writing);
					uisat.Writing.UpperPcnt = Math.round(parseFloat(uisat.Writing.Upper) / parseFloat(uisat.Writing.Max) * 100);
				}
				catch (ex) {
					console.log(ex);
					uisat.Writing.Lower = 0; uisat.Writing.LowerPcnt = 0;
					uisat.Writing.Middle = 0; uisat.Writing.MiddlePcnt = 0;
					uisat.Writing.Upper = 0; uisat.Writing.UpperPcnt = 0;
				}
			}

			if (this.school.Admission.ACT != null) {
				var act = this.school.Admission.ACT;
				var uiact = this.school.UIDt.Test.ACT;
				try {
					uiact.Lower = act.Percentile25.Cumulative == 0 || isNaN(act.Percentile25.Cumulative) ? 0 : parseInt(act.Percentile25.Cumulative);
					uiact.LowerPcnt = Math.round(parseFloat(uiact.Lower) / parseFloat(uiact.Max) * 100);
					uiact.Middle = act.Midpoint.Cumulative.length == 0 || isNaN(act.Midpoint.Cumulative) ? 0 : parseInt(act.Midpoint.Cumulative);
					uiact.MiddlePcnt = Math.round(parseFloat(uiact.Middle) / parseFloat(uiact.Max) * 100);
					uiact.Upper = act.Percentile75.Cumulative.length == 0 || isNaN(act.Percentile75.Cumulative) ? 0 : parseInt(act.Percentile75.Cumulative);
					uiact.UpperPcnt = Math.round(parseFloat(uiact.Upper) / parseFloat(uiact.Max) * 100);
				}
				catch (ex) {
					console.log(ex);
					uiact.Lower = 0; uiact.LowerPcnt = 0;
					uiact.Middle = 0; uiact.MiddlePcnt = 0;
					uiact.Upper = 0; uiact.UpperPcnt = 0;
				}
			}
		}
	}

	displayCost(): void {
		this.school.UIDt.Cost = {
			CollegeCost: {
				Max: 40000,
				Average: 0,
				AveragePcnt: 0,
				NationalAverage: 0,
				NationalAveragePcnt: 0
			},
			IncomeCost: [
				{ Income: "$0-$30,000", FamilyIncom: "0-30000", AverageCost: "" },
				{ Income: "$30,001-$48,000", FamilyIncom: "30001-48000", AverageCost: "" },
				{ Income: "$48,001-$75,000", FamilyIncom: "48001-75000", AverageCost: "" },
				{ Income: "$75,001-$110,000", FamilyIncom: "75001-110000", AverageCost: "" },
				{ Income: "$110,001+", FamilyIncom: "110001-plus", AverageCost: "" }
			]
		};
		var uicost = this.school.UIDt.Cost;
		if (this.school != null && this.school.Cost != null) {
			try {
				var cost = this.school.Cost;
				uicost.CollegeCost.Average = Math.round(cost.AverageAnnualCost.length == 0 || isNaN(cost.AverageAnnualCost) ? 0 : cost.AverageAnnualCost);
				uicost.CollegeCost.AveragePcnt = Math.round(parseFloat(uicost.CollegeCost.Average) / parseFloat(uicost.CollegeCost.Max) * 100);
				uicost.CollegeCost.AveragePcnt = uicost.CollegeCost.AveragePcnt > 100 ? 100 : uicost.CollegeCost.AveragePcnt;
				uicost.CollegeCost.NationalAverage = Math.round(cost.CostNationalAverage.length == 0 || isNaN(cost.CostNationalAverage) ? 0 : cost.CostNationalAverage);
				uicost.CollegeCost.NationalAveragePcnt = Math.round(parseFloat(uicost.CollegeCost.NationalAverage) / parseFloat(uicost.CollegeCost.Max) * 100);
				for (var i = 0; i < uicost.IncomeCost.length; i++) {
					for (var j = 0; j < cost.IncomeCost.length; j++) {
						if (uicost.IncomeCost[i]["FamilyIncom"] == cost.IncomeCost[j]["FamilyIncom"]) {
							uicost.IncomeCost[i]["AverageCost"] = (cost.IncomeCost[j]["AverageCost"].length > 0 && !isNaN(cost.IncomeCost[j]["AverageCost"]) ? Math.round(cost.IncomeCost[j]["AverageCost"]) : cost.IncomeCost[j]["AverageCost"]);
							break;
						}
					}
				}
			}
			catch (ex) {
				console.log(ex);
				uicost.Average = 0;
				uicost.AveragePcnt = 0;
				uicost.NationalAverage = 0;
				uicost.NationalAveragePcnt = 0;
				uicost.IncomeCost = [];
			}
		}
	}

	displayGraduationRetention(): void {
		this.school.UIDt.GR = {
			Graduation: {
				Max: 1,
				Average: 0,
				AveragePcnt: 0,
				NationalAverage: 0,
				NationalAveragePcnt: 0
			},
			Retention: {
				Max: 1,
				Average: 0,
				AveragePcnt: 0,
				NationalAverage: 0,
				NationalAveragePcnt: 0
			},
		};
		var uigr = this.school.UIDt.GR;
		if (this.school != null && this.school.GraduationRetention != null) {
			try {
				var gr = this.school.GraduationRetention;
				uigr.Graduation.Average = (gr.GraduationRate.length == 0 || isNaN(gr.GraduationRate) ? 0 : parseFloat(gr.GraduationRate)).toFixed(2);
				uigr.Graduation.NationalAverage = (gr.GraduationRateNationalAverage.length == 0 || isNaN(gr.GraduationRateNationalAverage) ? 0 : parseFloat(gr.GraduationRateNationalAverage)).toFixed(2);
				uigr.Graduation.AveragePcnt = Math.round(parseFloat(uigr.Graduation.Average) / parseFloat(uigr.Graduation.Max) * 100);
				uigr.Graduation.NationalAveragePcnt = Math.round(parseFloat(uigr.Graduation.NationalAverage) / parseFloat(uigr.Graduation.Max) * 100);
				uigr.Retention.Average = (gr.StudentsWhoReturnAfter1stYear.length == 0 || isNaN(gr.StudentsWhoReturnAfter1stYear) ? 0 : parseFloat(gr.StudentsWhoReturnAfter1stYear)).toFixed(2);
				uigr.Retention.NationalAverage = (gr.RetentionNationalAverage.length == 0 || isNaN(gr.RetentionNationalAverage) ? 0 : parseFloat(gr.RetentionNationalAverage)).toFixed(2);
				uigr.Retention.AveragePcnt = Math.round(parseFloat(uigr.Retention.Average) / parseFloat(uigr.Retention.Max) * 100);
				uigr.Retention.NationalAveragePcnt = Math.round(parseFloat(uigr.Retention.NationalAverage) / parseFloat(uigr.Retention.Max) * 100);
			}
			catch (ex) {
				console.log(ex);
				uigr.Graduation.Average = 0;
				uigr.Graduation.AveragePcnt = 0;
				uigr.Graduation.NationalAverage = 0;
				uigr.Graduation.NationalAveragePcnt = 0;
				uigr.Retention.Average = 0;
				uigr.Retention.AveragePcnt = 0;
				uigr.Retention.NationalAverage = 0;
				uigr.Retention.NationalAveragePcnt = 0;
			}
		}
	}

	displayFinancialAidDebt(): void {
		this.school.UIDt.Aid = {
			StudentsReceivingFederalLoans: 0,
			StudentsReceivingFederalLoansPcnt: 0,
			StudentsNotReceivingFederalLoans: 1,
			StudentsNotReceivingFederalLoansPcnt: 100,
			StudentsPayingDownTheirDebt: 0,
			PayingDownNationalAverage: 0,
			PayingDownNationalAveragePcnt: 0,
			TypicalTotalDebt: 0,
			TypicalMonthlyLoanPayment: 0,
			StudentsPayingDownTheirDebtPcnt: 0
		};
		var uiAid = this.school.UIDt.Aid;
		try {
			if (this.school != null && this.school.Aid != null) {
				var aid = this.school.Aid;
				uiAid.StudentsReceivingFederalLoans = aid.StudentsReceivingFederalLoans.length == 0 || isNaN(aid.StudentsReceivingFederalLoans) ? 0 : parseFloat(aid.StudentsReceivingFederalLoans).toFixed(2);
				uiAid.StudentsReceivingFederalLoansPcnt = Math.round(uiAid.StudentsReceivingFederalLoans * 100);
				uiAid.StudentsNotReceivingFederalLoans = (1 - parseFloat(uiAid.StudentsReceivingFederalLoans)).toFixed(2);
				uiAid.StudentsNotReceivingFederalLoansPcnt = Math.round(uiAid.StudentsNotReceivingFederalLoans * 100);
				uiAid.StudentsPayingDownTheirDebt = aid.StudentsPayingDownTheirDebt.length == 0 || isNaN(aid.StudentsPayingDownTheirDebt) ? 0 : parseFloat(aid.StudentsPayingDownTheirDebt).toFixed(2);
				uiAid.StudentsPayingDownTheirDebtPcnt = Math.round(uiAid.StudentsPayingDownTheirDebt * 100);
				uiAid.PayingDownNationalAverage = aid.PayingDownNationalAverage.length == 0 || isNaN(aid.PayingDownNationalAverage) ? 0 : parseFloat(aid.PayingDownNationalAverage).toFixed(2);
				uiAid.PayingDownNationalAveragePcnt = Math.round(uiAid.PayingDownNationalAverage * 100);
				uiAid.TypicalTotalDebt = aid.TypicalTotalDebt.length == 0 || isNaN(aid.TypicalTotalDebt) ? 0 : Math.round(aid.TypicalTotalDebt);
				uiAid.TypicalMonthlyLoanPayment = aid.TypicalMonthlyLoanPayment.length == 0 || isNaN(aid.TypicalMonthlyLoanPayment) ? 0 : Math.round(aid.TypicalMonthlyLoanPayment);
			}
		}
		catch (ex) {
			console.log(ex);
			uiAid.StudentsReceivingFederalLoans = 0;
			uiAid.StudentsReceivingFederalLoansPcnt = 0,
			uiAid.StudentsNotReceivingFederalLoans = 1;
			uiAid.StudentsNotReceivingFederalLoansPcnt = 100;
			uiAid.StudentsPayingDownTheirDebt = 0;
			uiAid.StudentsPayingDownTheirDebtPcnt = 0;
			uiAid.PayingDownNationalAverage = 0;
			uiAid.PayingDownNationalAveragePcnt = 0;
			uiAid.TypicalTotalDebt = 0;
			uiAid.TypicalMonthlyLoanPayment = 0;
		}
	}

	displayEarningsAfterSchool(): void {
		this.school.UIDt.EAS = {
			AboveHighSchoolGrad: 0,
			AboveHighSchoolGradPcnt: 0,
			Max: 100000,
			Average: 0,
			AveragePcnt: 0,
			NationalAverage: 0,
			NationalAveragePcnt: 0
		};
		var uieas = this.school.UIDt.EAS;
		if (this.school != null && this.school.EarningAterSchool != null) {
			try {
				var eas = this.school.EarningAterSchool;
				uieas.AboveHighSchoolGrad = (eas.AboveHighSchoolGrad.length == 0 || isNaN(eas.AboveHighSchoolGrad) ? 0 : parseFloat(eas.AboveHighSchoolGrad)).toFixed(2);
				uieas.AboveHighSchoolGradPcnt = Math.round(uieas.AboveHighSchoolGrad * 100);
				uieas.Average = (eas.SalaryAfterAttending.length == 0 || isNaN(eas.SalaryAfterAttending) ? 0 : Math.round(eas.SalaryAfterAttending));
				uieas.AveragePcnt = Math.round(parseFloat(uieas.Average) / parseFloat(uieas.Max) * 100);
				uieas.AveragePcnt = uieas.AveragePcnt > 100 ? 100 : uieas.AveragePcnt;
				uieas.NationalAverage = (eas.SalaryNationalAverage.length == 0 || isNaN(eas.SalaryNationalAverage) ? 0 : Math.round(eas.SalaryNationalAverage));
				uieas.NationalAveragePcnt = Math.round(parseFloat(uieas.NationalAverage) / parseFloat(uieas.Max) * 100);
			}
			catch (ex) {
				console.log(ex);
				uieas.AboveHighSchoolGrad = 0;
				uieas.AboveHighSchoolGradPcnt = 0;
				uieas.Average = 0;
				uieas.AveragePcnt = 0;
				uieas.NationalAverage = 0;
				uieas.NationalAveragePcnt = 0;
			}
		}
	}

	displaySchool(): void {
		try { this.displayTestScore(); } catch (ex) { console.log(ex); }
		try { this.displayCost(); } catch (ex) { console.log(ex); }
		try { this.displayGraduationRetention(); } catch (ex) { console.log(ex); }
		try { this.displayFinancialAidDebt(); } catch (ex) { console.log(ex); }
		try { this.displayEarningsAfterSchool(); } catch (ex) { console.log(ex); }
	}

	// college follower
	collegeFollowers: any = 0;
	testScores: any[] = [];

	setTestScores(): void {
		this.testScores = [];
		let ind: number = 0, stop: boolean = false, typeDefined: boolean = false;
		Object.keys(this.school.UIDt.Test).forEach((key) => {
			var testType:string = key;
			if (typeof this.school.UIDt.Test[key] === 'object') {
				var testTypeObj:any = this.school.UIDt.Test[key];
				Object.keys(testTypeObj).forEach((catKey) => {
					if (stop === false) {
						this.testScores[ind] = {};
						if (typeof testTypeObj[catKey] === "object") {
							var catValue:any = testTypeObj[catKey];
							this.testScores[ind] = catValue;
							if (catKey.toLocaleLowerCase() === "reading") {
								this.testScores[ind].SubType = "Critical Reading";
							}
							else {
								this.testScores[ind].SubType = catKey;
							}
							if (typeDefined === false) {
								this.testScores[ind].Type = testType;
								typeDefined = true;
							}
							ind++;
						}
						else {
							this.testScores[ind] = testTypeObj;
							this.testScores[ind].Type = testType;
							stop = true;
						}
					}
				});
			}
			stop = false;
		});
		//console.log(this.testScores);
	}

	setAtGlanceData(): void {
		var noStyle: boolean = true;
		this.atAGlanceData = [
			{
				icon: "icnBuildingColumns",
				iconType: "css",
				dataType: "html",
				text: this.school.SchoolYear + ' year',
				data: this.schoolYear(noStyle)
			},
			{
				icon: "icnUsers",
				iconType: "css",
				dataType: "html",
				text: "Undergraduate Students",
				data: this.studentSize(noStyle)
			},
			{
				icon: "icnLocationDot",
				iconType: "css",
				dataType: "html",
				text: "Location",
				data: this.schoolLocation(noStyle)
			},
			{
				icon: "icnPencil",
				iconType: "css",
				dataType: "html",
				text: "Classrooms",
				data: this.classsrooms(noStyle),
			},
			{
				icon: "icnMoneyBill1",
				iconType: "css",
				dataType: "html",
				text: "Cost",
				data: this.cost(noStyle)
			},
			{
				icon: "icnGraduationCap",
				iconType: "css",
				dataType: "html",
				text: "Graduation Rate",
				data: this.graduationRate(noStyle)
			},
			{
				icon: '<span class="fa-stack fa-xs"><i class="icnClockRotateLeft fa-flip-horizontal fa-stack-2x"></i><i class="icnUser fa-stack-1x"></i></span>',
				iconType: "html",
				dataType: "html",
				text: "Returning students",
				data: this.returningStudents(noStyle)
			},
			{
				icon: "icnBriefcase",
				iconType: "css",
				dataType: "html",
				text: "After School Earnings",
				data: this.earningsAfterSchool(noStyle)
			},
			{
				icon: "icnDollarSign",
				iconType: "css",
				dataType: "html",
				text: 'Paying Down Debt',
				data: this.studentPayingDownDebt(noStyle)
			}
		];
	}

	private hasLog: boolean = false;
	iconList = {
		'academicPrograms': false,
		'testScore': false,
		'cost': false,
		'graduationRate': false,
		'studentReturn': false,
		'financialAid': false,
		'totalDebt': false,
		'payingDebt': false,
		'monthlyLoan': false,
		'earning': false,
		'salary': false
	};

	colSocialStatusDefined: boolean = false;
	tempCareerDescObj = {
		'otherJobs': [] as any[],
		'Follow': null as any,
		'Favorite': null as any,
		'FollowCount': 0,
		'isOccupation': true
	};
	iconImage: string  = "";
	objectTitle: string = "";
	insertBr: boolean = true;
	objectURL: string = "";
	gMapSubTitle: string = "";
	schoolDataDefined: boolean = false;

	ngOnInit(): void {
		this.CSCSrv.gatherUrlFilter();
		this.schoolId = this.route.snapshot.paramMap.get("schoolId");
		this.schoolId = this.schoolId == null ? "" : this.schoolId.trim();
		if (this.schoolId.length == 0 || isNaN(parseInt(this.schoolId))) {
			this.status = 2;
		}
		else {
			if (!this.hasLog) {
				this.hasLog = true;
				this.activityAPI.log('IPEDS', 'View', this.schoolId, '', '').subscribe();
			}
			this.CSCAPI.getSchool(this.schoolId).subscribe(
				response => {
					this.status = 1;
					this.school = response;
					//console.log(response);
					this.iconImage = this.school.SchoolLogo;
					this.objectTitle = this.school.Name;
					this.objectURL = this.schoolURL();
					this.gMapSubTitle = this.school.City + ', ' + this.school.State + ' ' + this.school.ZipCode;
					this.setAtGlanceData();
					this.schoolDataDefined = true;
					this.school.UIDt = {}; // add the place holder to store UI data
					this.displaySchool();
					this.setTestScores();
					this.onResize(null);
				},
				err => {
					this.status = 2;
					this.school = null;
					console.log(err);
				}
			);
		}
	};
}


@Component({
	selector: 'app-college-scorecard-description',
	templateUrl: './college-scorecard-description.component.html',
	styleUrls: ['./college-scorecard.scss'],
	standalone: false
})
export class CollegeScorecardDescriptionComponent implements OnInit {
	constructor(
		private socialAPI: SocialObjectAPIService,
		private utilitySrv: UtilityService
	) { }

	@Input() objectId: string = '';
	@Input() objectName: string = "";
	@Input() objectIcon: string = "";
	@Input() coverImg: string = "";
	@Input() objectUrl: string = "";

	source: ESocialSourceType = ESocialSourceType.CollegeScorecard;
	coverImageDefault: string = "/API/Images/CSC/Background.png";
	objectIconDefault: string = "/API/Images/CSC/Logo.png";
	mobileView: boolean = AppSettingService.widgetMobile();
	toggled: boolean = this.mobileView ? true : false;
	followers: number = 0;

	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.mobileView = AppSettingService.widgetMobile();
		this.toggled = this.mobileView ? true : false;
	}

	displayInfoWrapper() {
		var title = this.objectName;
		if (this.objectName.length > 35) {
			title = this.objectName.substring(0, 34) + "...";
		}
		this.utilitySrv.openReadMoreDialog(title, '', this.objectUrl);
	}

	socialToggled(arg: any) {
		//console.log(arg);
		this.countData();
	};

	openNewFeatureModal(): void {
		this.utilitySrv.openNewFeatureDialog2B(null);
	};

	countData(): void {
		this.socialAPI.countSocialObjectFollow("3", "0", this.objectId, false).subscribe(
			response => {
				this.followers = response;
			},
			err => {
				console.log(err);
				this.followers = 0;
			}
		);
	};

	ngOnInit(): void {
		this.countData();

		if (this.coverImg.length > 0) {
			if (this.objectUrl !== "") {
				this.coverImg = AppSettingService.appConfig.JourneyAPIUrl + "Web/screenshot?url=" + this.objectUrl;
			}
		}
		// these functions are used to call back, use bind to force "this" is itself
		this.socialToggled = this.socialToggled.bind(this);
	}
}


@Component({
	selector: 'app-college-scorecard-test-score',
	templateUrl: './college-scorecard-test-score.component.html',
	styleUrls: ['./college-scorecard.scss'],
	standalone: false
})
export class CollegeScorecardTestScoreComponent implements OnInit {
	constructor(
		private utilitySrv: UtilityService) {
	}

	@Input() data: any = null;

	title: string = "Test Scores";
	iconList = { 'testScore': false };
	appUtility = AppUtilityService;
	toggled: boolean = AppSettingService.widgetMobile();
	showMinimize: boolean = AppSettingService.widgetMobile();
	objectIdForCollapsingWidget = this.title.replace(/ /g, '').replace('&', '') + "ID";
	size: string = "large";
	lgView: boolean = true;
	
	@HostListener('window:resize', ['$event']) onResize(event: any) {
		this.showMinimize = AppSettingService.widgetMobile();
		this.toggled = !this.showMinimize ? false : this.toggled;
		this.setView();
	}

	toggleCollapse (): void {
		this.toggled = !this.toggled;
	}

	setView() : void{
		if (window.innerWidth > AppSettingService.mobileBreakPoint) {
			this.lgView = true;
		}
		else {
			this.lgView = false;
		}
	}

	displayInfoWrapper(title: any, desc: any, className: any) {
		if (typeof className !== undefined && className.length > 0) {
			(this.iconList as any)[className] = true;
		}
		this.utilitySrv.openReadMoreDialog(title, desc, "");
	}

	ngOnInit(): void {
		setTimeout(()=>{ this.setView(); });
	}
}


@Component({
	selector: 'app-college-scorecard-graduate',
	templateUrl: './college-scorecard-graduate.component.html',
	styleUrls: ['./college-scorecard.scss'],
	standalone: false
})
export class CollegeScorecardGraduationRetentionComponent implements OnInit {
	constructor(
		private utilitySrv: UtilityService) {
	}

	@Input() data: any = null;

	title: string = "Graduation & Retention";
	iconList = { 'graduationRate': false, 'studentReturn': false };
	appUtility = AppUtilityService;
	toggled: boolean = AppSettingService.widgetMobile();
	showMinimize: boolean = AppSettingService.widgetMobile();
	objectIdForCollapsingWidget = this.title.replace(/ /g, '').replace('&', '') + "ID";
	size: string = "large";
	lgView: boolean = true;

	@HostListener('window:resize', ['$event']) onResize(event: any) {
		this.showMinimize = AppSettingService.widgetMobile();
		this.toggled = !this.showMinimize ? false : this.toggled;
		this.setView();
	}

	toggleCollapse(): void {
		this.toggled = !this.toggled;
	}

	setView(): void {
		if (window.innerWidth > AppSettingService.mobileBreakPoint) {
			this.lgView = true;
		}
		else {
			this.lgView = false;
		}
	}

	displayInfoWrapper(title: any, desc: any, className: any) {
		if (typeof className !== undefined && className.length > 0) {
			(this.iconList as any)[className] = true;
		}
		this.utilitySrv.openReadMoreDialog(title, desc, "");
	}

	ngOnInit(): void {
		setTimeout(() => { this.setView(); });
	}
}


@Component({
	selector: 'app-college-scorecard-cost',
	templateUrl: './college-scorecard-cost.component.html',
	styleUrls: ['./college-scorecard.scss'],
	standalone: false
})
export class CollegeScorecardCostComponent implements OnInit {
	constructor(
		private utilitySrv: UtilityService) {
	}

	@Input() data: any = null;

	title: string = "Cost";
	iconList = { 'cost': false };
	appUtility = AppUtilityService;
	toggled: boolean = AppSettingService.widgetMobile();
	showMinimize: boolean = AppSettingService.widgetMobile();
	objectIdForCollapsingWidget = this.title.replace(/ /g, '').replace('&', '') + "ID";
	size: string = "large";
	lgView: boolean = true;
	
	@HostListener('window:resize', ['$event']) onResize(event: any) {
		this.showMinimize = AppSettingService.widgetMobile();
		this.toggled = !this.showMinimize ? false : this.toggled;
		this.setView();
	}

	toggleCollapse(): void {
		this.toggled = !this.toggled;
	}

	setView(): void {
		if (window.innerWidth > AppSettingService.mobileBreakPoint) {
			this.lgView = true;
		}
		else {
			this.lgView = false;
		}
	}

	displayInfoWrapper(title: any, desc: any, className: any) {
		if (typeof className !== undefined && className.length > 0) {
			(this.iconList as any)[className] = true;
		}
		this.utilitySrv.openReadMoreDialog(title, desc, "");
	}

	ngOnInit(): void {
		setTimeout(() => { this.setView(); });
	}
}


@Component({
	selector: 'app-college-scorecard-financial-aid',
	templateUrl: './college-scorecard-financial-aid.component.html',
	styleUrls: ['./college-scorecard.scss'],
	standalone: false
})
export class CollegeScorecardFinancialAidComponent implements OnInit {
	constructor(
		private utilitySrv: UtilityService) {
	}

	@Input() data: any = null;

	title: string = "Financial Aid & Debt";
	iconList = { 'financialAid': false, 'payingDebt': false, 'totalDebt': false, 'monthlyLoan': false };
	appUtility = AppUtilityService;
	toggled: boolean = AppSettingService.widgetMobile();
	showMinimize: boolean = AppSettingService.widgetMobile();
	objectIdForCollapsingWidget = this.title.replace(/ /g, '').replace('&', '') + "ID";
	size: string = "large";
	lgView: boolean = true;

	@HostListener('window:resize', ['$event']) onResize(event: any) {
		this.showMinimize = AppSettingService.widgetMobile();
		this.toggled = !this.showMinimize ? false : this.toggled;
		this.setView();
	}

	toggleCollapse(): void {
		this.toggled = !this.toggled;
	}

	createPie(): void {
		var svgEl = document.querySelector('#financePie' + this.size);
		if (svgEl == undefined) {
			return;
		}
		var slices = [
			{ percent: this.data.StudentsReceivingFederalLoans - 0, color: "#56dcc4" },
			{ percent: this.data.StudentsNotReceivingFederalLoans - 0, color: "#3498db" }
		];

		var cumulativePercent = 0;

		function getCoordinatesForPercent(percent: any) {
			var x = Math.cos(2 * Math.PI * percent);
			var y = Math.sin(2 * Math.PI * percent);
			return [x, y];
		}

		for (var i = 0; i < slices.length; i++) {
			var slice = slices[i];
			// destructuring assignment sets the two variables at once
			var startXY = getCoordinatesForPercent(cumulativePercent);
			// each slice starts where the last slice ended, so keep a cumulative percent
			cumulativePercent += slice.percent;
			var endXY = getCoordinatesForPercent(cumulativePercent);
			// if the slice is more than 50%, take the large arc (the long way around)
			var largeArcFlag = slice.percent > .5 ? 1 : 0;
			// create an array and join it just for code readability
			var pathData = "M " + startXY[0] + " " + startXY[1]  // Move
				+ " A 1 1 0 " + largeArcFlag + " 1 " + endXY[0] + " " + endXY[1] // Arc
				+ " L 0 0"; // Line
			// create a <path> and append it to the <svg> element
			var pathEl = document.createElementNS('http://www.w3.org/2000/svg', 'path');
			pathEl.setAttribute('d', pathData);
			pathEl.setAttribute('fill', slice.color);
			svgEl.appendChild(pathEl);
		};
	}

	pieStyle: any = null;
	setView(): void {
		let width = window.innerWidth;
		this.pieStyle = { 'height': '130px', 'transform': 'rotate(-90deg)' };
		if (width > AppSettingService.mobileBreakPoint) {
			this.lgView = true;
			if (width > 1280) {
				this.pieStyle = { 'height': '150px', 'transform': 'rotate(-90deg)' };
			}
		}
		else {
			this.lgView = false;
		}
	}

	displayInfoWrapper(title: any, desc: any, className: any) {
		if (typeof className !== undefined && className.length > 0) {
			(this.iconList as any)[className] = true;
		}
		this.utilitySrv.openReadMoreDialog(title, desc, "");
	}

	ngOnInit(): void {
		setTimeout(() => { this.createPie(); }, 1000);
		setTimeout(() => { this.setView(); });
	}
}


@Component({
	selector: 'app-college-scorecard-earning-after-school',
	templateUrl: './college-scorecard-earning-after-school.component.html',
	styleUrls: ['./college-scorecard.scss'],
	standalone: false
})
export class CollegeScorecardEarningAfterSchoolComponent implements OnInit {
	constructor(
		private utilitySrv: UtilityService) {
	}

	@Input() data: any = null;

	title: string = "Earnings After School";
	iconList = { 'earning': false, 'salary': false };
	appUtility = AppUtilityService;
	toggled: boolean = AppSettingService.widgetMobile();
	showMinimize: boolean = AppSettingService.widgetMobile();
	objectIdForCollapsingWidget = this.title.replace(/ /g, '').replace('&', '') + "ID";
	size: string = "large";
	lgView: boolean = true;	

	@HostListener('window:resize', ['$event']) onResize(event: any) {
		this.showMinimize = AppSettingService.widgetMobile();
		this.toggled = !this.showMinimize ? false : this.toggled;
		this.setView();
	}

	toggleCollapse(): void {
		setTimeout(() => {
			if (this.toggled == false) {
				this.toggled = true;
			}
			else {
				this.toggled = false;
			}
		}, 200);
	}

	setView(): void {
		if (window.innerWidth > AppSettingService.mobileBreakPoint) {
			this.lgView = true;
		}
		else {
			this.lgView = false;
		}
	}

	displayInfoWrapper(title: any, desc: any, className: any) {
		if (typeof className !== undefined && className.length > 0) {
			(this.iconList as any)[className] = true;
		}
		this.utilitySrv.openReadMoreDialog(title, desc, "");
	}

	ngOnInit(): void {
		setTimeout(() => { this.setView(); });
	}
}


@Component({
	selector: 'app-college-scorecard-at-a-glance',
	templateUrl: './college-scorecard-at-a-glance.component.html',
	styleUrls: ['./college-scorecard.scss', '../map/atAGlance/at-a-glance.scss'],
	standalone: false
})
export class CollegeScorecardAtAGlanceComponent implements OnInit {
	constructor() { }

	@Input() iconList: IAtAGlanceItem[];
	toggled: boolean = AppSettingService.widgetMobile();
	showMinimize: boolean = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event']) onResize(e: any) {
		this.showMinimize = AppSettingService.widgetMobile();
		this.toggled = !this.showMinimize ? false : this.toggled;
	}

	toggleCollapse(): void {
		this.toggled = !this.toggled;
	}

	isTypeDefined(type: any): boolean {
		if (typeof type !== undefined && type === 'html') {
			return true;
		}
		return false;
	}

	ngOnInit(): void {
		//console.log(this.iconList);
		this.onResize(null);
	}
}
